/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {
    id: 'navigation.data-suites.dashboards',
  },
});

const DashboardsItem = () => (
  <RouteLinkItem route="midas/data-forge/dashboards" title={messages.title} />
);

export default DashboardsItem;
